import ChakraProvider from "@pathwright/ux/src/components/chakra/ChakraProvider"
import React from "react"
import { SpaceIdentityFragment } from "@pathwright/graphql-client/src/generated"

function SpaceTheme({
  space,
  children
}: {
  space: SpaceIdentityFragment
  children: React.ReactNode
}) {
  const colorPalette = space.theme?.color_palette

  return colorPalette ? (
    <ChakraProvider brandColorPalette={colorPalette}>{children}</ChakraProvider>
  ) : (
    children
  )
}

export default SpaceTheme
